/* globals $ */

/**
 * Upload a file
 * @param {string} url - The url to send the request
 * @param {() => void} beforeSend - A function called before the upload request is sent
 * @param {{domId: string}} json - Additional data to be sent with the request
 * @param {any} file The file
 * @param {(data: any, status: string) => void} handleFileUploaded The file uploaded handler
 * @param {(status: string, response: any) => void} handleUploadError The upload error handler
 * @param {(progressPercentage: number) => void} handleUploadProgress The upload progress handler
 */
function upload(
	url,
	beforeSend,
	json,
	file,
	handleFileUploaded,
	handleUploadError,
	handleUploadProgress,
) {
	const formData = new FormData();
	formData.append('file', file);
	formData.append('json', JSON.stringify(json));
	$.ajax({
		type: 'POST',
		url,
		beforeSend,
		processData: false,
		contentType: false,
		dataType: 'JSON',
		data: formData,
		success: (data, textStatus) => {
			handleFileUploaded(data, textStatus);
		},

		error: (xhr, textStatus) => {
			handleUploadError(textStatus, JSON.parse(xhr.responseText));
		},

		xhr: () => {
			const xhr = $.ajaxSettings.xhr();
			xhr.upload.onprogress = (evt) => {
				const percentage = 100;
				const progressPercentage = Math.round(
					(evt.loaded / evt.total) * percentage,
				);
				handleUploadProgress(progressPercentage);
			};

			return xhr;
		},
	});
}

/**
 * Handle a file upload
 * @param {string} url - The url to send the request
 * @param {() => void} beforeSend - A function called before the upload request is sent
 * @param {{domId: string}} json - Additional data to be sent with the request
 * @param {(data: any, status: string) => void} handleFileUploaded The file uploaded handler
 * @param {(status: string, response: any) => void} handleUploadError The upload error handler
 * @param {(progressPercentage: number) => void} handleUploadProgress The upload progress handler
 */
export function handleFileUpload(
	url,
	beforeSend,
	json,
	handleFileUploaded,
	handleUploadError,
	handleUploadProgress,
) {
	const dom = document.getElementById(json.domId);
	if (dom) {
		const file = dom.files[0];
		const reader = new FileReader();
		upload(
			url,
			beforeSend,
			json,
			file,
			handleFileUploaded,
			handleUploadError,
			handleUploadProgress,
		);
		reader.readAsDataURL(file);
	}
}
